module.exports = __webpack_public_path__ + "img/DODGE.60d4f66.jpg";